/*
* @ngdoc Component
* @name app.dashboard.RvChangesComponent
* @description
* This component is used to manage the Rv history listing
* */
import { Component, OnInit } from '@angular/core';

import { CommonService } from '../../services/common.service';
import { DashboardService } from '../../services/dashboard.service';
import { AppSettings } from '../../configs/app-settings';

import { Subscription } from 'rxjs/internal/Subscription';
import { UntypedFormGroup } from '@angular/forms';
import { GaEventsService } from '../../services/ga-events.service';
@Component({
  selector: 'rv-changes',
  templateUrl: './rv-changes.component.html',
  styleUrls: ['./rv-changes.component.scss']
})
export class RvChangesComponent implements OnInit {

  isLoadingList: boolean = false;
  isPaging: boolean = false;
  vSubscription: Subscription;
  total = 0
  page: any = 1
  limit = 10;
  noMoreRec = false;
  rvHistoryList = []
  timeLineDateFormat;
  Htime;
  currentTotal = 0;
  constructor(private dashboardService: DashboardService, private commonService: CommonService, private appSettings: AppSettings, private gaEvent: GaEventsService) {
    this.timeLineDateFormat = this.appSettings.HISTORY_TIME_FORMAT
    this.Htime = this.appSettings.HISTORY_COMMENT_TIME
  }

  ngOnInit() {
    this.getRvHistoryList();
  }


  /*
  * @name getRvHistoryList
  * @param None
  * @description Api call for fetching the rv history list
  * @return none
  */
  getRvHistoryList(paging = false) {
    //this.disableScroll = false;
    this.toggleLoader(true, paging)
    let apiParams = {
      page: this.page,
      limit: this.limit
    }

    //this.commonService.sendUserTo('vehicle-list', apiParams)
    // cancel previous request
    if (this.vSubscription != null) {
      this.vSubscription.unsubscribe();
    }
    this.vSubscription = this.dashboardService.getRVChangesHistory(apiParams).subscribe(
      (result: any) => {
        try {
          let response = result;
          let historyData = response.data;
          if (this.page == 1) {
            this.total = historyData.total
          }
          this.currentTotal = historyData.total
          this.limit = historyData.limit
          this.page = historyData.page
          //console.log(this.vehicleList.length)
          if (this.currentTotal == 0 && paging === true) {
            this.noMoreRec = true;
          } else {
            this.noMoreRec = false;
          }
          if (historyData.records.length > 0) {
            this.appendRvHistoryListing(historyData.records)
            //this.vehicleList = vehicleData.records
          }
          ///console.log(this.vehicleList.length)
        } catch (e) {

        }
      },
      (error) => {
        //console.log(error)
        let response = error;
        this.toggleLoader(false, paging)
        if (response.message) {
          this.handleServerFormError(response.errors)
          this.commonService.showSnakeBar(response.message);
        } else {
          this.commonService.commonSnakeBar();
        }
      },
      () => {
        this.toggleLoader(false, paging)
      }
    )
  }

  /*
  * @name toggleLoader
  * @param None
  * @description toggle listing loaders
  * @return none
  */
  toggleLoader(show = false, paging = false) {
    if (paging == false) {
      this.isLoadingList = show
    } else {
      this.isPaging = show;
    }
  }

  /*
  * @name appendRvHistoryListing
  * @param None
  * @description add new Rv values after paginate
  * @return none
  */
  appendRvHistoryListing(newList = []) {
    if (newList.length > 0) {
      let newState = [];
      if (this.rvHistoryList.length > 0) {
        newState = this.rvHistoryList.slice();
      }
      newList.forEach(element => {
        newState.push(element)
      });
      this.rvHistoryList = newState
    }

  }


  /*
   * @name onScroll
   * @param newList:None
   * @description paginate on scroll
   * @return none
   */
  onScroll() {
    /*if (this.disableScroll === true) {
      return false;
    }*/
    if (this.isLoadingList === true || this.isPaging === true) {
      return false;
    }
    //console.log(this.page, 'this.page')
    let page = parseInt(this.page);
    this.page = page + 1;
    //console.log(this.page, 'this.page')
    if (this.total > 10) {
      // console.log('onScroll request')
      this.getRvHistoryList(true)
      let gaData = {
        'event': 'rvDashboardHistory',
        'value': this.page
      }
      this.gaEvent.sendGaTagConfigData(gaData)
    }
  }

  /*
  * @name formValidate
  * @param  Form
  * @description validate form                       
  * @return none
  */
  formValidate(formGroup: UntypedFormGroup) {
    /*Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.formValidate(control);
      }
    });*/
  }

  /*
  * @name handleServerFormError
  * @param Form
  * @description handle server side errors                  
  * @return none
  */
  handleServerFormError(errors) {
    /*if (Object.keys(errors).length > 0) {
      Object.keys(errors).forEach((key) => {
        if (this.loginForm.contains(key)) {
          let control = this.loginForm.get(key);
          control.markAsTouched({ onlySelf: true });
          control.setErrors({ 'incorrect': true })
          this.formError[key] = errors[key];
        }
      });
    }*/
  }

  ngOnDestroy() {
    if (this.vSubscription) {
      this.vSubscription.unsubscribe()
    }
  }

  getClass(value) {
    let className;
    if (value == null) {
      className = ''
    } else if (value <= 0) {
      className = 'text-danger'
    } else if (value >= 0) {
      className = 'text-success'
    }
    return className
  }

  copiedMsg(param) {
    this.commonService.showSnakeBar(param);
  }

}
